<template>
  <div>
    <div style="padding: 14px;">
      网元名称:<span>{{item.name}}</span><br />
      网元别名:<span>{{item.alias}}</span><br />
      网元版本:<span>{{item.version}}</span><br />
      网元类型:<span>{{item.networkUnitType}}</span><br />
      模块数量:<span>{{item.moduleList.length}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "Unit",
  props: {
    item: {
      type: Object,
      required: true,
      default: {}
    }
  }
};
</script>